// ========================================
// Mediahold Ingest History API Types
// ========================================

export interface SeasonTitle {
  id: number;
  title: string;
  title_en: string;
  slug: string;
}

export interface MediaholdIngestHistoryItem {
  id: number;
  created: string;
  modified: string;
  provider_type: string;
  raw_body: string;
  raw_body_json: Record<string, any>;
  program_name: string;
  episode_no: string;
  on_air_date: string;
  section_no: string;
  season_id: number | null;
  season_title: SeasonTitle | null;
  network: string;
  subtitle_url: string;
  processed: 'pending' | 'completed' | 'failed';
  content_id: number | null;
  fail_count: number;
  error_message: string | null;
}

export type MediaholdIngestHistoryDetail = MediaholdIngestHistoryItem;

export interface MediaholdStats {
  total: number;
  pending: number;
  completed: number;
  failed: number;
}

// ========================================
// Enums
// ========================================

export enum ProcessedStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export enum ProviderType {
  MEDIAHOLD = 'mediahold',
  KCP = 'kcp',
}

// ========================================
// Color Constants
// ========================================

export const PROCESSED_STATUS_COLORS: Record<string, string> = {
  pending: 'orange',
  completed: 'green',
  failed: 'red',
};

export const PROVIDER_TYPE_COLORS: Record<string, string> = {
  mediahold: 'blue',
  kcp: 'purple',
};
